import React from 'react';
import { motion } from 'framer-motion';

const features = [
  { icon: 'bi-cash', title: 'Low Cost' },
  { icon: 'bi-palette', title: 'Modern Design' },
  { icon: 'bi-megaphone', title: 'Good Marketing' },
  { icon: 'bi-wifi', title: 'Free WiFi' },
  { icon: 'bi-geo-alt', title: 'Easy to Find' },
  { icon: 'bi-check-circle', title: 'Reliable' }
];

export default function WelcomeSection() {
  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="container  py-5"
    >
      <div className="row align-items-center">
        <div className="col-lg-6">
          <h2 className="text-3xl font-bold mb-4">Welcome to Bed Space</h2>
          <h3 className="text-2xl mb-4">We Always Provide Priority to Our Customer</h3>
          <div className="row mt-4">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.1 * index }}
                className="col-md-6 d-flex align-items-center mb-3"
              >
                <i className={`bi ${feature.icon} fs-3 text-primary me-2`}></i>
                <span>{feature.title}</span>
              </motion.div>
            ))}
          </div>
        </div>
        <div className="col-lg-6">
          <img
            src="/images/feature.webp"
            alt="Property"
            className="img-fluid "
          />
        </div>
      </div>
    </motion.div>
  );
}
